import type { UrlObject } from 'node:url';

// Every agent now opens in the graphical builder. `mode=edit` flips the builder
// header CTA to "Publish".
export const resolveAgentBuilderRoute = (agentId: string, from?: 'custom'): UrlObject => {
  // `from` records that the composer sent the author here, so the header's back control can return
  // them to it rather than to the agents list.
  return { pathname: `/agents/${agentId}/builder`, query: from ? { mode: 'edit', from } : { mode: 'edit' } };
};

/** Where the builder's back control goes, given how the author got in. */
export const resolveBuilderBackRoute = (from: string | string[] | undefined): UrlObject =>
  // `resume` is what licenses the composer to restore the stashed plan. Without it, opening the
  // dialog fresh later in the same session would resurrect a composition the author had left.
  from === 'custom' ? { pathname: '/agents', query: { template: 'custom', resume: '1' } } : { pathname: '/agents' };
